import React from 'react';

import './Resources.css';


function Resources({cssClasses, resource}) {

    let resNumSymbolClass = ' resourceOneSymbol';

    if(resource.amount > 9){
        resNumSymbolClass = ' resourceTwoSymbol'
    }

    return (
        <div className={cssClasses}>
            <div className={'resourceAmount font-oswald-bold ' + resNumSymbolClass}>{resource.amount}</div>
            <div className='resourceInc font-oswald-bold'>+{resource.inc}</div>
        </div>
    );
}

export default Resources;
